export class Constants {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static numbers = {
    notificationShowTime: {
      forLongMessages: 10000 /* default: 5000 for kendo UI */
    }
  };

  public static routePaths = {
    substitutes: "substitutes",
    users: "users",
    admin: "admin",
    settings: "settings",
    roles: "roles"
  };

  public static routeParams = {
    circId: "circId",
    stepId: "stepId",
    prepareId: "prepareId",
    templateId: "templateId",
    userId: "userId"
  };

  public static queryParams = {
    action: "action",
    hostUrl: "SPHostUrl"
  };
}
